import { useEffect, useState } from 'react';

export const useFramePortalContainer = (rootNode?: HTMLElement) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const div = rootNode || document.createElement('div');
    document.body.appendChild(div);
    setContainer(div);
    return () => {
      if (document.body.contains(div)) {
        document.body.removeChild(div);
      }
    };
  }, [rootNode]);

  return { current: container };
};
